import { IStoryData, setStoryData } from '../../../../../store/storySlice';
import { BookModel, ICharacterOutlineByUser } from '../../../../../interfaces/book.interface';
import { CONFIG } from '../../../../../config/mainConfig';
import { AppDispatch } from '../../../../../store/store';

interface HandleStoryDataUpdateProps {
  dispatch: AppDispatch;
  storyData: IStoryData;
  bookData: BookModel | null;
  loadCharacterOutline: (outline: ICharacterOutlineByUser) => void;
}

const setCharacterOutline = (
  bookData: BookModel | null,
  storyData: IStoryData,
  loadCharacterOutline: (outline: ICharacterOutlineByUser) => void
) => {
  let outline: ICharacterOutlineByUser = {};

  if (!bookData?.illustrationCharacter && !storyData?.illustrationCharacter?.pageIndex) {
    outline = bookData?.characterOutlineByUser || {};
  } else if (storyData?.regeneratedNewCharacter === false) {
    outline =
      storyData?.illustrationCharacter?.pageData?.characterOutlineByUser ||
      bookData?.characterOutlineByUser ||
      {};
  } else if (storyData?.regeneratedNewCharacter === true) {
    outline = bookData?.illustrationCharacter?.characterOutlineByUser || {};
  }

  loadCharacterOutline(outline);
};

const handleStoryDataUpdate = ({
                                 dispatch,
                                 storyData,
                                 bookData,
                                 loadCharacterOutline
                               }: HandleStoryDataUpdateProps) => {
  if (bookData?.isImageProcessing) {
    dispatch(setStoryData({
      ...storyData,
      illustrationCharacter: { ...storyData.illustrationCharacter, isPortraitDeleted: false }
    }));
  } else {
    let uploadedImage = CONFIG.CHARACTER.DUMMY_IMAGE;
    if (!bookData?.illustrationCharacter && !storyData?.illustrationCharacter?.pageIndex) {
      uploadedImage = bookData?.uploadedImageUrl || uploadedImage;
    } else if (
      bookData?.illustrationCharacter?.pageIndex === storyData?.illustrationCharacter?.pageIndex &&
      storyData?.illustrationCharacter?.isPortraitDeleted === false
    ) {
      uploadedImage = bookData?.illustrationCharacter?.uploadedImage ||
        storyData?.illustrationCharacter?.pageData?.uploadedImage ||
        uploadedImage;
    } else {
      const isCustomCharacterId = !!storyData?.illustrationCharacter?.pageData?.customCharacterId;
      uploadedImage = isCustomCharacterId
        ? storyData?.illustrationCharacter?.pageData?.uploadedImage || uploadedImage
        : storyData?.illustrationCharacter?.pageData?.uploadedImage ||
        bookData?.uploadedImageUrl ||
        uploadedImage;
    }

    dispatch(setStoryData({
      ...storyData,
      uploadedImage
    }));

    setCharacterOutline(bookData, storyData, loadCharacterOutline);
  }
};

export default handleStoryDataUpdate;
